import { render, staticRenderFns } from "./Producto.vue?vue&type=template&id=a1e85f4e"
import script from "./Producto.vue?vue&type=script&lang=js"
export * from "./Producto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports